module.exports = __webpack_public_path__ + "img/Q-bee-mailing.bec13ac8.svg";